<template>
  <div class="osk-product-seller">
    <UikitUser
      v-if="seller"
      :user="seller"
      size="m"
      show-follow
      show-date
      hide-type
      @change-follow="handleChange"
      @user-click="handleUserClick"
    />
    <div
      v-if="description"
      class="osk-product-seller__description"
    >
      {{ description }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductDTORes } from '~/restAPI/data-contracts';
import { AnalyticsEvents } from '~/types/analytics';

const props = defineProps<{
  product: ProductDTORes
}>();

const { $addEvent } = useNuxtApp();

const seller = computed(() => props.product.seller);
const description = computed(() => props.product.description?.replaceAll('\r', ''));

function handleChange(value: boolean) {
  const event = value ? AnalyticsEvents.UserSubscribe : AnalyticsEvents.UserUnsubscribe;

  $addEvent(event, { ...props.product });
}

function handleUserClick() {
  $addEvent(AnalyticsEvents.SellerClick, { ...props.product });
}
</script>

<style lang="scss" scoped>
@import "~/assets/scss/settings/index";

.osk-product-seller {
  &__description {
    margin-top: 24px;
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
